import React from 'react';
import { useState } from 'react';
import './RealWeb.css';
// import Cookies from 'js-cookie';
import InitProgram from '../components/loadinProgram/InitProgram';
// import axios from 'axios';
import AsciiNameApp from '../components/ascii-art/AsciiNameApp';
import MainMenu from '../components/menus/MainMenu';
const RealWeb = () => {
	const [endLine, setEndLine] = useState(false);
	const date = new Date();
	const releaseDate = new Date('2023-11-17');
	const days = Math.floor((releaseDate - date) / (1000 * 60 * 60 * 24));

	return (
		<>
			<main className="main-real-web">
				{!endLine ? (
					<InitProgram setEndLine={setEndLine}></InitProgram>
				) : (
					<>
						<div className='real-web-header'>
							<AsciiNameApp></AsciiNameApp>
							<div>By @Nixoals</div>
							<div>release date j-{days}</div>
						</div>
						<MainMenu></MainMenu>
					</>
				)}
			</main>
		</>
	);
};

export default RealWeb;
